/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Resource_Allocations_EndInputs */

const en_admin_resources_resource_allocations_end = /** @type {(inputs: Admin_Resources_Resource_Allocations_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`End`)
};

const de_admin_resources_resource_allocations_end = /** @type {(inputs: Admin_Resources_Resource_Allocations_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ende`)
};

const es_admin_resources_resource_allocations_end = /** @type {(inputs: Admin_Resources_Resource_Allocations_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fin`)
};

const fr_admin_resources_resource_allocations_end = /** @type {(inputs: Admin_Resources_Resource_Allocations_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fin`)
};

const nl_admin_resources_resource_allocations_end = /** @type {(inputs: Admin_Resources_Resource_Allocations_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einde`)
};

/** @type {(inputs: Admin_Resources_Resource_Allocations_EndInputs) => LocalizedString} */
const it_admin_resources_resource_allocations_end = en_admin_resources_resource_allocations_end;

/** @type {(inputs: Admin_Resources_Resource_Allocations_EndInputs) => LocalizedString} */
const pt_br2_admin_resources_resource_allocations_end = en_admin_resources_resource_allocations_end;

/** @type {(inputs: Admin_Resources_Resource_Allocations_EndInputs) => LocalizedString} */
const pl_admin_resources_resource_allocations_end = en_admin_resources_resource_allocations_end;

/** @type {(inputs: Admin_Resources_Resource_Allocations_EndInputs) => LocalizedString} */
const hu_admin_resources_resource_allocations_end = en_admin_resources_resource_allocations_end;

/** @type {(inputs: Admin_Resources_Resource_Allocations_EndInputs) => LocalizedString} */
const ro_admin_resources_resource_allocations_end = en_admin_resources_resource_allocations_end;

/**
* | output |
* | --- |
* | "End" |
*
* @param {Admin_Resources_Resource_Allocations_EndInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_resource_allocations_end = /** @type {((inputs?: Admin_Resources_Resource_Allocations_EndInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Resource_Allocations_EndInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_resource_allocations_end(inputs)
	if (locale === "de") return de_admin_resources_resource_allocations_end(inputs)
	if (locale === "es") return es_admin_resources_resource_allocations_end(inputs)
	if (locale === "fr") return fr_admin_resources_resource_allocations_end(inputs)
	if (locale === "nl") return nl_admin_resources_resource_allocations_end(inputs)
	if (locale === "it") return it_admin_resources_resource_allocations_end(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_resource_allocations_end(inputs)
	if (locale === "pl") return pl_admin_resources_resource_allocations_end(inputs)
	if (locale === "hu") return hu_admin_resources_resource_allocations_end(inputs)
	return ro_admin_resources_resource_allocations_end(inputs)
});
export { admin_resources_resource_allocations_end as "admin.resources.resource_allocations.end" }